import React from 'react';
import { datetime } from "../../../../../util/library/datetime";
import {
    certainType,
    changeLog,
    eventType,
    KeyChangeLog,
    MONTH_DATE_FORMAT,
    SHORT_DATETIME_FORMAT,
    SHORT_TIME_FORMAT
} from "../../../../../util/varibles/constants";
import { convertNumberTimeToStringTime, convertStepName, durationTxt, firstLetter } from "../../../../../util/varibles/global";
import { IDifferenceLogs } from "../../../../../util/varibles/interface";
import styles from './style.module.scss';
import Units from "./Units";

export const view = {
    simple: (key: KeyChangeLog, viewOld: any, viewNew: any) => {
        const { name } = changeLog[key] || {};
        return <>{name} changing from <b>{viewOld}</b> to <b>{viewNew}</b>.</>
    }
}

interface IProps {
    data: IDifferenceLogs
}

const Differences: React.FC<IProps> = (props) => {
    const { [KeyChangeLog.TASKS]: tasks, [KeyChangeLog.SUB_OPS]: sub_ops, ...data } = props.data || {};

    return <div className={styles.differences}>
        {Object.keys(data || {}).map(key => {
            switch (key) {
                case KeyChangeLog.START_TIME:
                case KeyChangeLog.FINISH_TIME: {
                    const { new: value, old } = data[key] || {};
                    const timeA = datetime(old).format(MONTH_DATE_FORMAT);
                    const timeB = datetime(value).format(MONTH_DATE_FORMAT);
                    const format = timeA === timeB ? SHORT_TIME_FORMAT : SHORT_DATETIME_FORMAT
                    const viewOld = datetime(old).format(format)
                    const viewNew = datetime(value).format(format)
                    return <div key={key} className={styles.difference}>
                        {view.simple(key, viewOld, viewNew)}
                    </div>
                }
                case KeyChangeLog.DURATION: {
                    const { new: value, old } = data[key] || {};
                    const viewOld = durationTxt(old || 0)
                    const viewNew = durationTxt(value || 0)
                    return <div key={key} className={styles.difference}>
                        {view.simple(key, viewOld, viewNew)}
                    </div>
                }
                case KeyChangeLog.CERTAIN_MODE: {
                    const { new: value, old } = data[key] || {};
                    const { name: viewOld } = certainType[old];
                    const { name: viewNew } = certainType[value];
                    return <div key={key} className={styles.difference}>
                        {view.simple(key, viewOld, viewNew)}
                    </div>
                }
                case KeyChangeLog.EVENT_TYPE: {
                    const { new: value, old } = data[key] || {};
                    const { name: viewOld } = eventType[old];
                    const { name: viewNew } = eventType[value];
                    return <div key={key} className={styles.difference}>
                        {view.simple(key, viewOld, viewNew)}
                    </div>
                }
                case KeyChangeLog.PARALLEL: {
                    const { new: value } = data[key] || {};
                    const { name } = changeLog[key];
                    const actionText = value ? 'Turn on' : "Turn off";
                    return <div key={key} className={styles.difference}>
                        {firstLetter([actionText, name].join(' '))}
                    </div>
                }
                case KeyChangeLog.NOTE: {
                    const { new: value, old } = data[key] || {}
                    if ((value || '').length > 0 && (old || '').length > 0)
                        return <div key={key} className={styles.difference}>
                            {view.simple(key, old, value)}
                        </div>
                    else {
                        const { name } = changeLog[key];
                        const viewText = value || old;
                        if ((value || '').length > 0) {
                            return <div key={key} className={styles.difference}>
                                Add {name.toLowerCase()}: <b>{viewText}</b>
                            </div>
                        } else {
                            return <div key={key} className={styles.difference}>
                                Remove {name.toLowerCase()}
                            </div>
                        }
                    }
                }
                case KeyChangeLog.VESSEL_NAME: {
                    const { new: value = '', old = '' } = data[key] || {};
                    return <div key={key} className={styles.difference}>
                        {view.simple(key, old, value)}
                    </div>
                }
                case KeyChangeLog.CLEANING: {
                    const { new: value } = data[key];
                    const { name } = changeLog[key];
                    return <div key={key} className={styles.difference}>
                        {firstLetter([value ? 'Add' : "Remove", name].join(' '))}
                    </div>
                }
                case KeyChangeLog.DELAY_TIME: {
                    const { new: value } = data[key] || {};
                    const { key: stepKey = '', time_late = 0 } = value || {};
                    const timeText = convertNumberTimeToStringTime(time_late);
                    const stepName = convertStepName([stepKey])[0] || "";
                    const { name } = changeLog[key] || {};
                    return <div key={key} className={styles.difference}>
                        {name}: <b>{stepName} ({timeText})</b>.
                    </div>
                }
                case KeyChangeLog.ROUTER_ID: {
                    return <div key={key} className={styles.difference}>
                        Route has been changed
                    </div>
                }
                case KeyChangeLog.FILES: {
                    const { new: value = [], old = [] } = data[key];
                    if (value.length > 0 && old.length > 0) {
                        return <div key={key} className={styles.difference}>
                            Attached file has been updated
                        </div>
                    } else {
                        return <div key={key} className={styles.difference}>
                            {value.length > 0 ? "Add" : 'Deleted'} attachments
                        </div>
                    }
                }
                case KeyChangeLog.CHECKLIST: {
                    const { new: value = [], old = [] } = data[key];
                    return [
                        value.length > 0 && <div key={key + "new"} >
                            {value.length > 1 ? "Checklists" : "Checklist"} added : {value.join(", ")}
                        </div>,
                        old.length > 0 && <div key={key + "old"} >
                            {value.length > 1 ? "Checklists" : "Checklist"} deleted : {old.join(", ")}
                        </div>
                    ]
                }
                case KeyChangeLog.PAUSE: {
                    const { new: value = {}, old = {} } = data[key];
                    console.log(data[key], key)
                    const { start_time, finish_time, est_finish_time: newCompleteTime = 0 } = value;
                    const { est_start_time = 0, est_finish_time: oldCompleteTime = 0 } = old || {};
                    const oldFinishTime = datetime(oldCompleteTime);
                    const newFinishTime = datetime(newCompleteTime)
                    const format = oldFinishTime.format(MONTH_DATE_FORMAT) === newFinishTime.format(MONTH_DATE_FORMAT) ? SHORT_TIME_FORMAT : SHORT_DATETIME_FORMAT
                    const oldDuration = durationTxt(oldCompleteTime - est_start_time)
                    const newDuration = durationTxt(newCompleteTime - est_start_time)
                    return finish_time
                        ? <div key={key + "new"} >
                            <div>Resumed on {datetime(finish_time).format(SHORT_DATETIME_FORMAT)}</div>
                            <div>Pause duration: {durationTxt(finish_time - start_time)}</div>
                            {!!old && <>
                                <div>{view.simple(KeyChangeLog.FINISH_TIME, oldFinishTime.format(format), newFinishTime.format(format))}</div>
                                <div>{view.simple(KeyChangeLog.DURATION, oldDuration, newDuration)}</div>
                            </>}
                        </div>
                        : <div key={key + "new"} >Start paused on {datetime(start_time).format(SHORT_DATETIME_FORMAT)}</div>
                }
                default: {
                    return null
                }
            }
        })}
        <Units tasks={tasks} sub_ops={sub_ops} />
    </div>;
};

export default Differences;
